// Unversioned prepared packages retain these original pixels, independently of
// the editable/default map palette. Keep their generator and reader in sync.
export const LEGACY_TERRAIN_STOPS = Object.freeze([
  Object.freeze({position:0,color:'#a96c58'}),
  Object.freeze({position:25,color:'#bc9880'}),
  Object.freeze({position:50,color:'#c6c1a4'}),
  Object.freeze({position:75,color:'#9ba98b'}),
  Object.freeze({position:100,color:'#6f8c7c'}),
 ]);

export const DEFAULT_TERRAIN_SETTINGS = Object.freeze({
 stops: Object.freeze([
  Object.freeze({position:0,color:'#b2182b'}),
  Object.freeze({position:25,color:'#ef5b32'}),
  Object.freeze({position:50,color:'#f4d35e'}),
  Object.freeze({position:75,color:'#7fcdbb'}),
  Object.freeze({position:100,color:'#225ea8'}),
 ]),
});

export function validateTerrainSettings(value) {
 if(!value||typeof value!=='object'||Array.isArray(value)||Object.keys(value).some(key=>key!=='stops'))return 'Choose a terrain gradient.';
 const stops=value.stops;
 if(!Array.isArray(stops)||stops.length<2||stops.length>8)return 'Use between 2 and 8 colors.';
 for(let i=0;i<stops.length;i++){
  const stop=stops[i];
  if(!stop||typeof stop!=='object'||Array.isArray(stop)||Object.keys(stop).some(key=>!['position','color'].includes(key)))return 'Each color needs a position and a hex color.';
  if(!Number.isInteger(stop.position)||stop.position<0||stop.position>100)return 'Color positions must be whole percentages from 0 to 100.';
  if(typeof stop.color!=='string'||!/^#[0-9a-f]{6}$/i.test(stop.color))return 'Use a six-digit hex color, such as #6f8c7c.';
  if(i>0&&stop.position<=stops[i-1].position)return 'Color positions must increase from lower to higher ground.';
 }
 if(stops[0].position!==0||stops.at(-1).position!==100)return 'The first color must start at 0% and the last at 100%.';
 return null;
}

export function normalizeTerrainSettings(settings){
 const error=validateTerrainSettings(settings);if(error)throw new Error(error);
 return {stops:settings.stops.map(({position,color})=>({position,color:color.toLowerCase()}))};
}

export function terrainGradientCss(stops=DEFAULT_TERRAIN_SETTINGS.stops){
 const settings=normalizeTerrainSettings({stops});
 return 'linear-gradient(90deg, '+settings.stops.map(stop=>stop.color+' '+stop.position+'%').join(', ')+')';
}

/** The preview, map legend and USGS colormap all use the same stop positions. */
export function sampleTerrainGradient(stops,position){
 const rgb=color=>[1,3,5].map(at=>parseInt(color.slice(at,at+2),16));
 const at=Math.max(0,Math.min(100,position));
 const end=stops.findIndex(stop=>stop.position>=at);
 if(end<=0)return rgb(stops[end===0?0:stops.length-1].color);
 const a=stops[end-1],b=stops[end],fraction=(at-a.position)/(b.position-a.position),left=rgb(a.color),right=rgb(b.color);
 return left.map((value,i)=>Math.round(value+(right[i]-value)*fraction));
}
